import { Typography, useTheme } from '@automata/mui-theme';
import Stack from '@mui/material/Stack';
import Box from '@mui/system/Box';
import { CSSProperties } from 'react';

export type Props = {
  bgHeight?: CSSProperties['height'];
  textBoxHeight?: CSSProperties['height'];
};

const NoRunProgress = ({
  bgHeight = 500,
  textBoxHeight = 250,
}: Props): JSX.Element => {
  const theme = useTheme();
  return (
    <Box
      width="100%"
      height={bgHeight}
      sx={{
        bgcolor: theme.palette.primary[50],
      }}
    >
      <Box
        position="relative"
        width="100%"
        flex="1"
        height={textBoxHeight}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Stack>
          <Typography variant="h6" color="textSecondary" noWrap>
            No run progress for current workflow
          </Typography>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Typography color="textSecondary" noWrap>
              Press start to execute the workflow
            </Typography>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default NoRunProgress;
